import React from 'react';
import { Button, Icon } from '@folio/stripes/components';
import { t } from '../../../../services';
export var ActionButtonsList = function (_a) {
    var buttons = _a.buttons, handleClick = _a.handleClick;
    return (React.createElement(React.Fragment, null, buttons.map(function (btn) { return (React.createElement(Button, { key: btn.label, type: "button", buttonStyle: "dropdownItem", role: "menuitem", value: btn.label, disabled: btn.disabled, onClick: function () { return handleClick(btn.onClick); } },
        React.createElement(Icon, { icon: btn.icon }, t("pane.dropdown.".concat(btn.label))))); })));
};
